import axios from 'axios'
var contratoNumero = '5453'
localStorage.setItem('contrato',contratoNumero)
export const http = axios.create({
  //baseURL: 'http://apppanterafood.com.br/DeliveryCenter/3/cardapio/',
  //baseURL: 'http://192.168.1.27/cardapio/',
  //baseURL: './', //LOCAL DA RAIZ
  baseURL: './php-deli',
  //baseURL: '../cardapio/', //SERVIDOR DA PASTA 3
  //baseURL: "./php-qrcode", //LOCAL DA PASTA 3
  contrato: "",
});